import { Link } from "@tanstack/react-router"
import { Button } from "../components/ui"
import { Home, Frown } from "lucide-react"

/** 404 page. Shown when no route matches the URL. */
export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-background to-muted px-4 text-center">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-card shadow-lg">
        <Frown className="h-10 w-10 text-muted-foreground" />
      </div>
      <h1 className="mb-2 text-4xl font-bold tracking-tight">404</h1>
      <p className="mb-6 max-w-xs text-muted-foreground">We couldn't find the page you're looking for.</p>
      <Link to="/">
        <Button>
          <Home className="mr-2 h-4 w-4" /> Back home
        </Button>
      </Link>
    </div>
  )
}
